<template>
  <div class="form-group">
    <fieldset>
      <legend class="sr-only">{{ $t('triptype') }}</legend>
      <input type="radio" name="triptype" checked value="oneway" id="oneway" v-model="tripType" @change="updateValue" />
      <label class="radio-inline" for="oneway">{{ $t('oneway') }}</label>
      <input type="radio" name="triptype" value="roundtrip" v-model="tripType" id="roundtrip" @change="updateValue" />
      <label class="radio-inline" for="roundtrip">{{ $t('roundtrip') }}</label>
    </fieldset>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tripType: "oneway"
    };
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    }
  },
  watch: {
    tripType:{
      handler(){
        
      },
      immediate: true,
    }
  }
};
</script>
<style lang="scss">
.radio-inline {
  padding-left: 0px !important;
  padding-right: 20px;
  input {
    margin-left: 0px;
    top: 0;
    right: 0;
  }
}
</style>
